var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarDeviceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6166 7.7763L16.95 6.94297C16.6416 6.79297 16.2583 6.90964 16.1083 7.21797C15.95 7.53464 16.075 7.90964 16.3833 8.05964L17.7083 8.71797V12.7096L14.5833 12.718V4.16797C14.5833 2.5013 13.4666 1.66797 12.0833 1.66797H5.41663C4.03329 1.66797 2.91663 2.5013 2.91663 4.16797V17.7096H1.66663C1.32496 17.7096 1.04163 17.993 1.04163 18.3346C1.04163 18.6763 1.32496 18.9596 1.66663 18.9596H15.8333C16.175 18.9596 16.4583 18.6763 16.4583 18.3346C16.4583 17.993 16.175 17.7096 15.8333 17.7096H14.5833V13.968L18.3333 13.9596C18.6833 13.9596 18.9583 13.6763 18.9583 13.3346V8.33464C18.9583 8.1013 18.825 7.88464 18.6166 7.7763ZM4.99996 5.74297C4.99996 4.58464 5.70829 4.16797 6.57496 4.16797H10.9333C11.7916 4.16797 12.5 4.58464 12.5 5.74297V6.76797C12.5 7.91797 11.7916 8.33464 10.925 8.33464H6.57496C5.70829 8.33464 4.99996 7.91797 4.99996 6.75964V5.74297ZM5.41663 10.2096H7.91663C8.25829 10.2096 8.54163 10.493 8.54163 10.8346C8.54163 11.1763 8.25829 11.4596 7.91663 11.4596H5.41663C5.07496 11.4596 4.79163 11.1763 4.79163 10.8346C4.79163 10.493 5.07496 10.2096 5.41663 10.2096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDeviceActive);
export default __webpack_public_path__ + "static/media/sidebar-device-active.be6d7fac09a99fa5e93a7ca01ee1e308.svg";
export { ForwardRef as ReactComponent };